
/* Business Unit select values */
export const BUSINESS_UNIT_VALUES = (lang) => [
  {
    id: "SW5zdGFuY2VOb2RlOjE=",
    label: "CALYPSO",
    value: "SW5zdGFuY2VOb2RlOjE=",
  },
  {
    id: "SW5zdGFuY2VOb2RlOjQ=",
    label: lang === "es" ? "EUROPA" : "EUROPE",
    value: "SW5zdGFuY2VOb2RlOjQ=",
  },
  {
    id: "SW5zdGFuY2VOb2RlOjE=",
    label: "LATAM",
    value: "SW5zdGFuY2VOb2RlOjE=",
  },
  {
    id: "SW5zdGFuY2VOb2RlOjM=",
    label: "USA",
    value: "SW5zdGFuY2VOb2RlOjM=",
  }
]